import { store } from '../../../../resources/frontend/js/store';
import 'data-layer-helper/dist/data-layer-helper';

const layerListener = (model, message) => {
    if (Object.values(model).includes('consent')) {
        const modelCookieConsent = model[2];
        const newConsent = JSON.stringify(modelCookieConsent);

        store.commit('page/setValue', { key: 'cookieConsent', value: newConsent });
    }
}

export const layerHelper = () => {
    return new window.DataLayerHelper(window.dataLayer, layerListener);
}
